import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import ShipmentRulesModalBasicFormComponent from '@/modules/configurationModule/detail/shipments/shipment-rules/components/shipment-rules-modal-basic-form/shipment-rules-modal-basic-form.vue'
import ShipmentRulesModalBasicForm from '@/modules/configurationModule/detail/shipments/shipment-rules/components/shipment-rules-modal-basic-form/shipment-rules-modal-basic-form'
import ShipmentRulesModalAssayRelationships from '@/modules/configurationModule/detail/shipments/shipment-rules/components/shipment-rules-modal-assay-relationships/shipment-rules-modal-assay-relationships.vue'
import ConfigurationRelationships
    from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { BModal } from 'bootstrap-vue'
import {
    initialShipmentRulesModalState,
    ShipmentRulesModalState
} from '@/modules/configurationModule/detail/shipments/shipment-rules/components/shipment-rules-modal/shipment-rules-modal.model'
import {
    ShipmentRuleCreateRequest,
    ShipmentRulePatchInBatchRequest, ShipmentRuleResponse
} from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule/shipment-rule.dto'
import { ShipmentRulesModalBasicDataState } from '@/modules/configurationModule/detail/shipments/shipment-rules/components/shipment-rules-modal-basic-form/shipment-rules-modal-basic-form.model'
import { CommonLaboratoryResponse, EnumResponse } from '@/api/services/common.dto'
import { shipmentBlockingRulesAuxiliaryService } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-blocking-rules-auxiliary/shipment-blocking-rules-auxiliary.service'
import {
    ShipmentRuleBlockingCauseCreateRequest,
    ShipmentRuleBlockingCauseResponse
} from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-blocking-cause/shipment-rule-blocking-cause.dto'
import { shipmentRuleBlockingCauseService } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-blocking-cause/shipment-rule-blocking-cause.service'
import { shipmentRuleAssayService } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-assay/shipment-rule-assay.service'
import {
    ShipmentRuleAssayCreateRequest,
    ShipmentRuleAssayResponse
} from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-assay/shipment-rule-assay.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ShipmentRulesModalBasicFormComponent,
        ConfigurationRelationships,
        ShipmentRulesModalAssayRelationships
    }
})
export default class ShipmentRulesModal extends Vue {
    @Ref() readonly shipmentRulesModal!: BModal
    @Ref() basicDataForm!: ShipmentRulesModalBasicForm

    @Prop(String) readonly actionTitle!: string
    @Prop() readonly isManual!: boolean

    @Emit()
    create(basicData: ShipmentRulesModalBasicDataState): ShipmentRuleCreateRequest {
        return {
            active: basicData.active,
            assayId: basicData.assay?.id,
            caseOwnerLaboratoryId: basicData.caseOwnerLaboratory?.labId,
            destinationEntityInternalStatusCode: basicData.destinationEntityInternalStatus?.code,
            destinationLaboratoryId: basicData.destinationLaboratory?.labId,
            entityType: basicData.entityType?.code,
            originEntityInternalStatusCode: basicData.originEntityInternalStatus?.code,
            originLaboratoryId: basicData.originLaboratory?.labId,
            priority: basicData.priority,
            sampleTypeId: basicData.sampleType?.id,
            topographicCodeId: basicData.topographicCode?.id
        }
    }

    @Emit()
    update(basicData: ShipmentRulesModalBasicDataState): ShipmentRulePatchInBatchRequest[] {
        return [{
            id: basicData.id,
            active: basicData.active,
            assayId: basicData.assay?.id ?? null,
            caseOwnerLaboratoryId: basicData.caseOwnerLaboratory?.labId ?? null,
            destinationEntityInternalStatusCode: basicData.destinationEntityInternalStatus?.code ?? null,
            destinationLaboratoryId: basicData.destinationLaboratory?.labId ?? null,
            entityType: basicData.entityType?.code ?? null,
            originEntityInternalStatusCode: basicData.originEntityInternalStatus?.code ?? null,
            originLaboratoryId: basicData.originLaboratory?.labId ?? null,
            priority: basicData.priority,
            sampleTypeId: basicData.sampleType?.id ?? null,
            topographicCodeId: basicData.topographicCode?.id ?? null
        }]
    }

    state: ShipmentRulesModalState
    constructor() {
        super()
        this.state = initialShipmentRulesModalState()
    }

    get relationshipsTabDisabled(): boolean {
        return !this.shipmentRuleId
    }

    get shipmentRuleAssayTabDisabled(): boolean {
        return !this.state.basicData.caseOwnerLaboratory || !this.shipmentRuleId
    }

    get shipmentRuleId(): Nullable<number> {
        return this.state.basicData.id
    }

    onCaseOwnerLaboratoryChanged(caseOwnerLaboratory: CommonLaboratoryResponse) {
        this.state.basicData.caseOwnerLaboratory = caseOwnerLaboratory
    }

    onEntityTypeChanged(entityType: EnumResponse) {
        this.state.basicData.entityType = entityType
    }

    async updateRow(shipmentRuleResponse: ShipmentRuleResponse) {
        if (shipmentRuleResponse) {
            this.state.basicData = {
                ...shipmentRuleResponse,
                entityType: {
                    code: shipmentRuleResponse.entityType.code,
                    translatedName: shipmentRuleResponse.entityType.translatedName
                },
                comboOptions: {
                    sampleTypes: [],
                    topographicCodes: [],
                    assays: [],
                    originStates: [],
                    destinationStates: []
                }
            }
            await this.getShipmentRuleBlockingCauses()
        }
    }

    async show(shipmentRuleResponse: ShipmentRuleResponse): Promise<void> {
        this.state = initialShipmentRulesModalState()
        await this.updateRow(shipmentRuleResponse)
        await this.getShipmentRulesBlockingCauses()
        this.shipmentRulesModal.show()
    }

    async getShipmentRuleBlockingCauses(): Promise<void> {
        const filterModel = {
            'shipmentRule.id': GridUtils.getNumberFilterModel('equals', this.state.basicData.id)
        }
        const response = await this.$_toCallUnique(shipmentRuleBlockingCauseService.paginator(filterModel, {}))
        if (response) {
            this.state.blockingCauses = response.content
        } else {
            this.state.blockingCauses = []
        }
    }

    async getShipmentRulesBlockingCauses(): Promise<void> {
        const response = await this.$_toCallUnique(shipmentBlockingRulesAuxiliaryService.getAllShipmentBlockingCauses())
        if (response) {
            this.state.comboOptions.shipmentRulesBlockingCauses = response
        } else {
            this.state.comboOptions.shipmentRulesBlockingCauses = []
        }
    }

    async createShipmentRuleBlockingCause(shipmentRuleBlockingCause: EnumResponse): Promise<ShipmentRuleBlockingCauseResponse | null> {
        const shipmentRuleBlockingCauseCreateRequest: ShipmentRuleBlockingCauseCreateRequest = {
            shipmentBlockingCause: shipmentRuleBlockingCause.code,
            shipmentRuleId: this.state.basicData.id
        }
        const response = await this.$_toCallUnique(shipmentRuleBlockingCauseService.createShipmentRuleBlockingCause(shipmentRuleBlockingCauseCreateRequest))
        if (response) {
            return response
        }
        return null
    }

    async createShipmentRuleAssay(shipmentRuleAssay: ShipmentRuleAssayCreateRequest): Promise<StrictNullable<ShipmentRuleAssayResponse>> {
        const response = await this.$_toCallUnique(shipmentRuleAssayService.createShipmentRuleAssay(shipmentRuleAssay))
        if (response) {
            return response
        }
        return null
    }

    async deleteShipmentRuleBlockingCause(shipmentRuleBlockingCauseId: number): Promise<void> {
        if (shipmentRuleBlockingCauseId) {
            await this.$_toCallUnique(shipmentRuleBlockingCauseService.deleteShipmentRuleBlockingCauseById(shipmentRuleBlockingCauseId))
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
        }
    }

    async onShipmentRulesBlockingCausesCreate(shipmentRuleBlockingCause: EnumResponse) {
        const createShipmentRuleBlockingCauseResponse = await this.createShipmentRuleBlockingCause(shipmentRuleBlockingCause)
        if (createShipmentRuleBlockingCauseResponse) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            await this.getShipmentRuleBlockingCauses()
        }
    }

    async onShipmentRulesBlockingCausesDelete(shipmentRuleBlockingCause: ShipmentRuleBlockingCauseResponse) {
        const shipmentRuleBlockingCauseId = shipmentRuleBlockingCause.id
        await this.deleteShipmentRuleBlockingCause(shipmentRuleBlockingCauseId)
        await this.getShipmentRuleBlockingCauses()
    }

    hide(): void {
        this.shipmentRulesModal.hide()
    }
}
